import { TapError, TapResponse } from '@iotize/tap';
import { ResultCode } from '@iotize/tap/client/api';
import { Subject } from 'rxjs';
import { TapServerError } from './tap-server-error';

export class VirtualVariableState {
  protected _values: Record<number, number> = {};

  protected _changes = new Subject<{
    id: number;
    newValue: number;
  }>();

  get valueChange() {
    return this._changes.asObservable();
  }

  setValue(id: number, value: number): void {
    this._values[id] = value;
    this._changes.next({
      id,
      newValue: value,
    });
  }

  getValue(id: number): number {
    if (!(id in this._values) || this._values[id] === undefined) {
      console.warn(`Request id "${id}" but this variable does not exist`);
      throw TapServerError.targetComError();
    }
    return this._values[id];
  }
}
